"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RatingFormatter;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Flag2 = _interopRequireDefault(require("@material-ui/icons/Flag"));

var _ThumbUp2 = _interopRequireDefault(require("@material-ui/icons/ThumbUp"));

var _Favorite2 = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _StarRounded2 = _interopRequireDefault(require("@material-ui/icons/StarRounded"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

RatingFormatter.propTypes = _propTypes.EditorProps;

function RatingFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column,
      onRowChange = _ref.onRowChange,
      isCellSelected = _ref.isCellSelected;
  var key = column.key,
      options = column.options,
      style = column.style;
  var max = (options === null || options === void 0 ? void 0 : options.max) || 5;
  var value = row[key] || 0;
  var isEditable = column.isEditable;
  var iconType;
  var data = [];

  switch (style === null || style === void 0 ? void 0 : style.type) {
    case "star":
      iconType = /*#__PURE__*/_react["default"].createElement(_StarRounded2["default"], {
        fontSize: "small"
      });
      break;

    case "heart":
      iconType = /*#__PURE__*/_react["default"].createElement(_Favorite2["default"], {
        fontSize: "small"
      });
      break;

    case "like":
      iconType = /*#__PURE__*/_react["default"].createElement(_ThumbUp2["default"], {
        fontSize: "small"
      });
      break;

    case "flag":
      iconType = /*#__PURE__*/_react["default"].createElement(_Flag2["default"], {
        fontSize: "small"
      });
      break;

    default:
      iconType = /*#__PURE__*/_react["default"].createElement(_StarRounded2["default"], {
        fontSize: "small"
      });
      break;
  }

  for (var i = 0; i < max; i++) {
    data.push(iconType);
  }

  var handleSelect = function handleSelect(item) {
    if (isEditable) {
      onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, key, item || value)));
    }
  };

  return value || isCellSelected ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      height: "100%",
      alignItems: "center"
    }
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      key: index,
      style: {
        cursor: "pointer",
        marginRight: 1,
        color: value && index < value ? style === null || style === void 0 ? void 0 : style.color : "rgba(156, 163, 175, 1)",
        display: "flex"
      },
      onClick: function onClick() {
        return handleSelect(index + 1);
      }
    }, item);
  })) : null;
}